import { createContext } from "react";

// genes registered in the fusion object (structural components and regulatory elements)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GeneContext = createContext({} as any);
